// GEP-7047: countries where an open/pending invoice balance is checked for
// past-due status instead of unconditionally blocking the order/upgrade.
// AU/NZ was the original scope; US/CA was added for GEP-7047.
// GB and all other regions are intentionally excluded (out of scope).
export const BALANCE_CHECK_COUNTRIES = ['AU', 'NZ', 'US', 'CA']

export const hasPastDueInvoice = openInvoices =>
  openInvoices?.some(invoice => invoice.state === 'past_due')
